const hashtags = [
  "名片",
  "明信片",
  "酷卡",
  "邀請卡",
  "海報",
  "婚禮小物",
  "杯墊",
  "鶯歌陶瓷杯墊",
  "台灣製陶瓷吸水杯墊",
  "珪藻土杯墊",
  "海報",
  "PP相紙",
  "帆布",
  "馬克杯",
  "荷葉扇",
  "數位印刷",
  "少量印刷",
];

module.exports = hashtags;
exports.default = hashtags;
